export const businesses = state => state.businesses
export const business = state => state.business
export const businessServices = state => state.businessServices
